import { Box } from '@material-ui/core';
import type { ReactNode } from 'react';

interface TrustListProps {
  items: ReactNode[];
}
/** A list container of trust building items under the step container */
export const TrustList = (props: TrustListProps): JSX.Element | null => {
  const { items } = props;
  if (!items?.length) {
    return null;
  }
  return (
    <Box border="1px solid #eff3f6" borderRadius={8}>
      {items.map((child, index) => (
        <Box key={`trust-list-${index}`} borderTop={index === 0 ? undefined : '1px solid #eff3f6'} padding={3}>
          {child}
        </Box>
      ))}
    </Box>
  );
};
